<template>
    <div>
        <div class="card mb-5 shadow">
            <div class="card-header">Contacts par défaut</div>
            <div class="card-body">
                <div class="row">
                    <!--                    <div class="col-4">-->
                    <!--                        <owner-contact-select-->
                    <!--                            :key="'ocs' + localKey"-->
                    <!--                            :company-id="company.id"-->
                    <!--                        />-->
                    <!--                    </div>-->
                    <div class="col-6">
                        <accounting-contact-select
                            :key="'acs' + localKey"
                            :company-id="company.id"
                        />
                    </div>
                    <div class="col-6">
                        <invoicing-contact-select
                            :key="'ics' + localKey"
                            :company-id="company.id"
                        />
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-5 shadow">
            <div class="card-header">Tous les contacts</div>
            <div class="card-body">
                <div>
                    <div v-if="searching">
                        <physical-person-search
                            @physical-person-is-set="update"
                        />
                    </div>
                    <div v-if="creating">
                        <contact-create
                            :company="company"
                            @contact-has-been-created="update"
                        />
                    </div>
                    <div v-if="!creating && !searching">
                        <div class="card shadow-sm mb-3">
                            <div class="card-body">
                                <table class="table table-sm border-0">
                                    <thead>
                                    <tr>
                                        <th class="td-icon"></th>
                                        <th style="width: 15%">Prénom</th>
                                        <th style="width: 15%">Nom</th>
                                        <th style="width: 20%">Fonction</th>
                                        <th style="width: 22%">Email</th>
                                        <th>Téléphone</th>
                                        <th>Mandataire</th>
                                        <!-- <th>Appli.</th> -->
                                        <th class="td-icon"></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <contact-edit
                                        v-for="contact in company.contacts"
                                        :key="'contact' + contact.id+localKey"
                                        :contact="contact"
                                        :chiefs="chiefs"
                                        @contact-is-updated="update"
                                        @contact-is-deleted="update"
                                    />
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <b-button variant="success" size="sm" @click="search">
                            Ajouter un contact
                        </b-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex'
import Loading from '../../../../common/components/loading.vue'
import ContactCreate from './ContactCreate.vue'
import ContactEdit from './ContactEdit.vue'
import PhysicalPersonSearch from '../physicalPersons/PhysicalPersonSearch.vue'

import OwnerContactSelect from './OwnerContactSelect.vue'
import AccountingContactSelect from './AccountingContactSelect.vue'
import InvoicingContactSelect from './InvoicingContactSelect.vue'
import chiefs from "../chiefs/Chiefs.vue";

export default {
    name: 'ContactsTable',

    components: {
        InvoicingContactSelect,
        AccountingContactSelect,
        OwnerContactSelect,
        Loading,
        ContactEdit,
        PhysicalPersonSearch,
        ContactCreate,
    },

    props: {
        company: {
            type: Object,
            required: true,
        },
        fullVue: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            localKey: '123',
        }
    },

    computed: {
        ...mapState({
            searching: (state) => state.legalVM.searching,
            creating: (state) => state.legalVM.creating,
        }),

        chiefs() {
            if (this.company.hasOwnProperty('chiefs')) {
                return this.company.chiefs === null
                    ? null
                    : this.company.chiefs.data
            }
            return null
        },
    },

    created() {
        this.$store.commit('legalVM/RESET_STATUS')
    },

    methods: {
        update() {
            if (this.fullVue) {
                this.$emit('update-company')
            }
            window.location.reload();

        },

        search() {
            this.$store.commit('legalVM/SET_CLIENT', this.company)
            this.$store.commit('legalVM/SET_LINK_TYPE', 'clientContacts')
            this.$store.commit('legalVM/SHOW_SEARCH')
        },
    },
}
</script>

<style scoped></style>
